import { graphql } from '@guuru/graphql-common/gql';
import communityExpertFragment from '../../../../graphql/fragments/CommunityExpertFragment';

export default graphql(
  `
    query GetPersistedExperts(
      $partnerId: ID!
      $first: Int
      $after: String
      $loadMore: Boolean!
    ) {
      community(id: $partnerId) {
        id
        experts(first: $first, after: $after) @connection(key: $first) {
          edges {
            node {
              ...CommunityExpertFragment
            }
          }
          pageInfo {
            hasNextPage @include(if: $loadMore)
            endCursor @include(if: $loadMore)
          }
        }
      }
    }
  `,
  [communityExpertFragment],
);
